import React from "react"
import { SignUpForm } from "../../components/SignUpForm"

export const SignUp = () => {
  return <SignUpForm />
}
